import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    clientName: {
      validations: [
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the client name.' }
      ]
    },
    firstName: {
      validations: [
        { type: 'maxLength', maxLength: 25, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide a first name.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'maxLength', maxLength: 25, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide a last name.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    addressLine1: {
      validations: [
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the street address.' }
      ]
    },
    city: {
      validations: [
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the city.' }
      ]
    },
    state: {
      validations: [
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the state.' }
      ]
    },
    postal: {
      validations: [
        { type: 'maxLength', maxLength: 15, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the zip code.' }
      ]
    },
    billClientName: {
      validations: [
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the Billing Client name.' }
      ]
    },
    billAddress: {
      validations: [
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the Billing Client Street address.' }
      ]
    },
    billCity: {
      validations: [
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the Billing Client city.' }
      ]
    },
    billState: {
      validations: [
        { type: 'maxLength', maxLength: 30, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the Billing Client state.' }
      ]
    },
    billPostal: {
      validations: [
        { type: 'maxLength', maxLength: 15, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide the Billing Client zip code. ' }
      ]
    },
    partyName: {
      validations: [
        { type: 'maxLength', maxLength: 75, message: 'Maximum number of characters reached' },      
        { type: 'required', message: 'Please provide the Event name.' }]
    },
    eventDate: {
      validations: [
        { type: 'maxLength', maxLength: 15, message: 'Please select one preferred date. You may add additional Event Dates to the Notes/Comments section below.' },
        { type: 'required', message: 'Please select a date for your event.' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    startTime: {
      validations: [
        { type: 'required', message: 'Please provide the Event start time.' }
      ]
    },
    endTime: {
      validations: [
        { type: 'required', message: 'Please provide the Event end time.' }
      ]
    },
    plannedGuestCount: {
      validations: [
        { type: 'maxLength', maxLength: 10, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please enter the number of people.' }
      ]
    },
    eventextra1: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please select one of the required options.' }
      ]
    },
    eventextra2: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please select one of the required options.' }
      ]
    },
    eventextra3: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of characters reached' },
        { type: 'required', message: 'Please provide details.' }
      ]
    },
    eventextra4: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: 'Maximum number of characters reached' },
      ]
    },
    notes: {
      validations: [
        { type: 'required', message: 'Please provide additional notes and comments.' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Your Contact Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Please complete one form per event.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Organization/Institution *',
            mapping: 'clientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Contact First Name *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Contact Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'telNumber'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Address *',
            mapping: 'addressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City *',
            mapping: 'city'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'State *',
            mapping: 'state'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code *',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Your Billing Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Billing Contact Name *',
            mapping: 'billClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Billing Address *',
            mapping: 'billAddress'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Billing City *',
            mapping: 'billCity'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Billing State *',
            mapping: 'billState'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Billing Zip Code *',
            mapping: 'billPostal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Your Event Details',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'XLarge',
            label: 'Event Name *',
            mapping: 'partyName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date *',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Please enter your preferred event date here. For any other date options, please enter them into the notes section below.',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time *',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'startTime'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'End Time *',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'endTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Guest Count *',
            mapping: 'plannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Room Setup *',
            options: [
              { label: 'Boardroom', value: 'Boardroom' },
              { label: 'Hollow Square', value: 'Hollow Square' },
              { label: 'Classroom', value: 'Classroom' },
              { label: 'U-Shape', value: 'U-Shape' },
              { label: 'Hybrid U-Shape', value: 'Hybrid U-Shape' },
              { label: 'Clusters', value: 'Clusters' },
              { label: 'Theater', value: 'Theater' },
              { label: 'Reception', value: 'Reception' }
            ],
            mapping: 'eventextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Will you need food & beverage? *',
            options: [
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' }
            ],
            mapping: 'eventextra2'
          }
        ]
      }, 
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Description of Meeting *',
            mapping: 'eventextra3'
          }
        ]
      },   
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Will you need video conferencing?',
            mapping: 'eventextra4'
          }
        ]
      },     
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Additional Notes and Comments *',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SEND'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Big Ten Conference Center Contact Form',
    formId: '487',
    clientKey: '115F03AB-645F-4C33-8080-0352C2469278',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/bigtencc/form_structure.js